<template>
    <div class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
                class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
            >
                <div
                    class="border overflow-hidden border-gray-200 dark:border-gray-900 sm:rounded-lg"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gray-200 dark:bg-gray-900">
                            <tr
                                class="text-gray-600 font-semibold dark:text-gray-500"
                            >
                                <th
                                    class="px-6 py-3 text-left text-xs leading-4 uppercase tracking-wider"
                                >
                                    Event
                                </th>
                                <th
                                    class="px-6 py-3 text-left text-xs leading-4 uppercase tracking-wider"
                                >
                                    When
                                </th>

                                <th
                                    class="px-6 py-3 text-left text-xs leading-4 uppercase tracking-wider"
                                >
                                    Status
                                </th>
                                <th class="px-6 py-3"></th>
                            </tr>
                        </thead>
                        <tbody class="bg-white dark:bg-gray-700">
                            <tr
                                v-for="(event, index) in displayedActivity"
                                :key="index"
                            >
                                <td
                                    class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900 dark:text-gray-300"
                                >
                                    {{ event.message }}
                                </td>

                                <hover-text
                                    :default="event.timeago"
                                    :hover="event.readableDate"
                                    tag="td"
                                    class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500 dark:text-gray-400 cursor-pointer"
                                />

                                <td
                                    class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
                                >
                                    <span
                                        class="rounded-full px-2 py-1 font-semibold uppercase bg-opacity-10"
                                        style="font-size: 10px;"
                                        :class="{
                                            'text-success bg-success':
                                                event.status === 'success',
                                            'text-error bg-error':
                                                event.status === 'error',
                                            'text-gray-600 bg-gray-500':
                                                event.status === 'info',
                                            'text-warning bg-warning':
                                                event.status === 'pending',
                                        }"
                                    >
                                        {{ event.status }}
                                    </span>
                                </td>

                                <td
                                    style="width: 50px;"
                                    class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
                                >
                                    <a
                                        v-if="event.status === 'error'"
                                        href=""
                                        class="font-semibold text-primary"
                                        >Contact us</a
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div
                    v-show="
                        displayedActivity.length < this.parsedActivity.length
                    "
                    class="w-full p-3 flex items-center justify-center"
                >
                    <button
                        @click="pagesShown++"
                        class="text-sm text-gray-700 p-1 rounded focus:outline-none focus:shadow-outline"
                    >
                        Show More
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import timeago from "epoch-timeago";
export default {
    name: "ModelRecentActivity",
    props: ["activity"],
    data() {
        return {
            pageSize: 5,
            pagesShown: 1,
        };
    },
    computed: {
        parsedActivity() {
            return this.activity
                .map((event) => {
                    let readableDate = new Date(+event.timestamp).toString();

                    readableDate = readableDate.split(" GMT")[0];

                    return {
                        ...event,
                        timeago: timeago(event.timestamp),
                        readableDate,
                    };
                })
                .reverse();
        },
        displayedActivity() {
            return this.parsedActivity.slice(
                0,
                this.pageSize * this.pagesShown
            );
        },
    },
};
</script>

<style lang="scss">
td {
    width: 240px;
}
</style>
